
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  EntitlementsAuthorizationsParameters,
  EntitlementsAuthorizationsParametersResponse,
} from '../entities/entitlements-v1/authorizations-parameters';
import { axiosInstance } from "../axios-instance";

class Entitlements {
  private baseUrl: string;

  private client: OAuth2Client | null;

  constructor(baseUrl: string, client: OAuth2Client | null) {
    this.baseUrl = baseUrl;
    this.client = client;
  }

  getEntitlementAuthorizations(
    input: EntitlementsAuthorizationsParameters,
  ): Promise<AxiosResponse<EntitlementsAuthorizationsParametersResponse>> {
    const { ...queryParameters } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<EntitlementsAuthorizationsParametersResponse>(
      `${this.baseUrl}/authorizations`,
      {
        params: queryParameters,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  updateLastLoginUserDetails(): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<any>(`${this.baseUrl}/users/lastLogin`,
      undefined,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
  }

  getUserRoleDetails(): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<any>(`${this.baseUrl}/parties`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }
}

export default Entitlements;
